import './Header.css'

export default () => {
    return (
        <div>
            <img src={"./logo_address_book.png"} />
        </div>
    );
}